import React, {useEffect, useState} from "react";
import TopBoxV2 from "../common/TopBoxV2";
import PageNameV2 from "../common/PageNameV2";
import PageTitleV2 from "../common/PageTitleV2";
import ShopSelectBoxV2 from "../common/ShopSelectBoxV2";
import {useShopAdminDetail2, useShopOrigin} from "../../../static/js/hock/shopHock";
import cooInfoIcon from "../../../static/image/v2/menu/cooInfoIcon.png";
import {openPopup} from "../../../static/js/Common2";
import MenuOriginPopupV2 from "./MenuOriginPopupV2";
import {subNavEvent} from "../../../static/js/service/commonService";

export default function MenuOriginV2() {
  const [shopList, setShopList] = useState([]);
  const [shopId, setShopId] = useState();
  const [origin, setOrigin] = useState([]);
  const [approvalTpcd1, setApprovalTpcd1] = useState();

  useShopOrigin({setOrigin}, shopId);
  useShopAdminDetail2({setApprovalTpcd1}, shopId);

  useEffect(() => {
    subNavEvent("menuNav", "menu3");
  }, []);

  const originBtn = (shopId, shopName, cooInfo) => {
    document.querySelector("#originPopup .shopName").setAttribute("data-id", shopId);
    document.querySelector("#originPopup .shopName").innerText = shopName;
    document.getElementById("menuOriginDesc").value = cooInfo;
    openPopup("originPopup");
  }

  const cooInfo = origin.map(({shopId, shopName, cooInfo}) => {
    return (
      <div key={shopId} className="commonBox cooInfoBox">
        <h3>{shopName}</h3>
        <p className={cooInfo === "" ? "red" : ""}>
          <img src={ cooInfoIcon } alt='' />
          {(cooInfo || "원산지를 등록해주세요.").split("\n").map((line, index) => (
            <React.Fragment key={index}>{line}<br /></React.Fragment>
          ))}
        </p>
        <div className="cooInfoBtnBox">
          {approvalTpcd1 === 4 &&
            <button
              className={`cooInfoBtn ${cooInfo === "" ? "active" : ""}`}
              onClick={() => originBtn(shopId, shopName, cooInfo)}
            >
              {cooInfo === "" ? "등록" : "수정"}
            </button>
          }

        </div>
      </div>
    )
  })

  return (
    <main id="MenuOriginV2" className="mainV2">
      <TopBoxV2 shopList={shopList} />
      <MenuOriginPopupV2 />
      
      <div className="container">
        <section className="containerInner">
          <PageNameV2 title1="메뉴 관리" title2="원산지" />
          <div className="pageTitle mb-10 d-flex a-center j-between">
            <PageTitleV2 title="원산지" countText="" count="" unit="" />
          </div>
          <div id="shopSelectBox" className="hide">
            <ShopSelectBoxV2 setShopId={setShopId} setShopList={setShopList} />
          </div>
          {cooInfo}
        </section>
      </div>
    </main>
  )
}